import axios from 'axios'

export default {
    state: {
        pageTo: '',
        pageFrom: '',

    },
    mutations: {

        updateRouteFrom(state, from) {
            state.pageFrom = from
        },
        updateRouteTo(state, to) {
            state.pageTo = to
        }
    },
    actions: {
        async checkAvailability({ctx}, payload) {
            return await axios.post(
                process.env.VUE_APP_API + '/check-availability',
                {mail: payload.mail},
                {
                    headers: {
                        'Authorization': localStorage.getItem('token')
                    }
                })
                .then(res => {
                    return res
                }).catch(error => {
                    return error.response
                })
        },
        async checkMailIsFree({ctx}, payload) {
            return await axios.post(
                process.env.VUE_APP_API + '/check-mail',
                {mail: payload.mail})
                .then(res => {
                    return res.data
                })
        },
        async checkInst(ctx, payload) {
            return await axios.post(
                process.env.VUE_APP_API + '/check/check-inst/' + payload.visit_id,
                {
                    id: payload.id,
                    check: payload.data,
                    user: {id: payload.visitor},
                    targetTypes: payload.targetTypes
                }
            ).then(res => {
                return res.data
            })
        },
        async checkTwi(ctx, payload) {
            return await axios.post(
                process.env.VUE_APP_API + '/check/check-twitter/' + payload.visit_id,
                {
                    id: payload.id,
                    check: payload.data,
                    user: {id: payload.visitor},
                }
            ).then(res => {
                return res.data;
            });
        },
        async checkTikTok(ctx, payload) {
            return await axios.post(
                process.env.VUE_APP_API + '/check/check-tiktok/' + payload.visit_id,
                {
                    id: payload.id,
                    check: payload.data,
                    user: {id: payload.visitor},
                }
            ).then(res => {
                return res.data;
            });
        },

        async checkLinkedIn(ctx, payload) {
            return await axios.post(
                process.env.VUE_APP_API + '/check/check-linkedin/' + payload.visit_id,
                {
                    id: payload.id,
                    check: payload.data,
                    user: {id: payload.visitor},
                }
            ).then(res => {
                return res.data;
            });
        },

        async checkYT(ctx, payload) {
            return await axios.post(
                process.env.VUE_APP_API + '/check/check-yt/' + payload.visit_id,
                {
                    id: payload.id,
                    check: payload.data,
                    user: payload.visitor,
                    targetTypes: payload.targetTypes
                }
            ).then(res => {
                return res.data
            })
        },
        async checkEm(ctx, payload) {
            return await axios.post(
                process.env.VUE_APP_API + '/check/check-email/' + payload.visit_id,
                {
                    user: payload.visitor,
                    project_name: payload.project_name,
                    project_id: payload.project_id,
                    tag_1: payload.tag_1,
                    tag_2: payload.tag_2,
                    code: payload.code,
                }
            ).then(res => {
                return res.data
            })
        },

        async checkFB({ctx}, payload) {
            return await axios.post(
                process.env.VUE_APP_API + '/check/check-fb/' + payload.visit_id,
                {
                    id: payload.id,
                    check: payload.check,
                    user: payload.visitor,
                    targetTypes: payload.targetTypes
                }
            ).then(res => {
                return res.data
            })
        },

        async changeResultVisit({ctx}, payload) {
            return await axios.get(
                process.env.VUE_APP_API + `/check/result/${payload.content_id}/${payload.token}`,
            ).then(res => {
                return res.data
            })
        },

        async visit({ctx}, payload) {
            return await axios.get(`${process.env.VUE_APP_API}/visit/${payload.content_id}/${payload.token}`)
                .then(res => {
                    return res.data.id
                })
        },

        async sendMessageToProve({ctx}, payload) {
            return await axios.post(`${process.env.VUE_APP_API}/prove-email`, {
                email: payload.email,
            }).then(res => res.data)
        },

        async sendMessageWhatsapp({ctx}, payload) {
            return await axios.post(`${process.env.VUE_APP_API}/send-whatsapp`, {
                phone: payload.phone,
            }).then(res => res.data)
        },

        async sendPhoneOnMessenger({ctx}, payload) {
            return await axios.post(`${process.env.VUE_APP_API}/send-code/`, {
                messengers: payload.messengers,
                overCount: payload.overCount
            }).then(res => res.data)
        },

        async sendCodeOnMessenger({ctx}, payload) {
            return await axios.post(`${process.env.VUE_APP_API}/prove-messengers/${payload.visit_id}`, {
                code: payload.code,
                phone: payload.phone,
                type: payload.type
            }).then(res => res.data)
        },

        async prepareDataToFbCheck({ctx}, payload) {
            const visitor = await axios.post(process.env.VUE_APP_API + '/check/type-fb', {check: payload.visitor})
                .then(res => {
                    return res.data
                })
            const pages = payload.pages.map(async (page, id) => {
                return await axios.post(
                    process.env.VUE_APP_API + '/check/type-fb',
                    {
                        check: page.account,
                    }
                ).then(res => {
                    return {id, data: res.data, visitor}
                })
            })
            return Promise.all(pages)
                .then(res => {
                    return res
                })
        },
        changeRouterTo({commit}, to) {
            commit('updateRouteTo', to)
        },
        changeRouterFrom({commit}, from) {
            commit('updateRouteFrom', from)
        }
    }
    ,
    getters: {
        getRoutes(state) {
            return {'to': state.pageTo, 'from': state.pageFrom}
        }
    }
}
